import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {IonButtons, IonFab, IonFabButton, IonHeader, IonIcon, IonPage} from "@ionic/react";
import {StyledIonContent, StyledIonTitle, StyledIonToolbar} from "@components/content/content.style";
import {add} from 'ionicons/icons';
import {StyledHeaderButton, StyledHeaderButtonImage} from "@components/button/button.style";
import AvailabilityPane, {AvailabilityPaneHandle} from "@app/availabilityPage/panes/availabilityPane.component";
import AvailabilityGuideModal from "@app/availabilityPage/modals/availabilityGuideModal.component";
import InfoImg from '@assets/images/info.svg';

const AvailabilityPage: React.FC = () => {
    const {t} = useTranslation();

    const header = useRef<HTMLIonHeaderElement>(null);
    const availabilityPaneRef = useRef<AvailabilityPaneHandle>(null);

    const [topEdge, updateTopEdge] = useState<number | undefined>(undefined);
    const [showGuide, updateShowGuide] = useState<boolean>(false);

    useEffect(() => {
        updateHeight();
    }, []);

    const updateHeight = () => {
        if (header.current?.clientHeight === 0) {
            setTimeout(updateHeight);
        } else {
            updateTopEdge(header.current?.clientHeight);
        }
    };

    const handleOpenNewAvailabilityModal = () => {
        availabilityPaneRef.current?.openAvailabilityAddModal();
    }

    return (
        <IonPage>
            <StyledIonContent>
                <IonHeader ref={header} className="ion-no-border">
                    <StyledIonToolbar>
                        <StyledIonTitle className="left">{t("profileTab.optionAvailability")}</StyledIonTitle>
                        <IonButtons slot="end">
                            <StyledHeaderButton onClick={() => updateShowGuide(true)}>
                                <StyledHeaderButtonImage src={InfoImg}></StyledHeaderButtonImage>
                            </StyledHeaderButton>
                        </IonButtons>
                    </StyledIonToolbar>
                </IonHeader>
                <AvailabilityPane ref={availabilityPaneRef} topEdge={topEdge}/>
                <IonFab slot="fixed" vertical="bottom" horizontal="end"
                        style={{marginBottom: 'calc(95px + var(--ion-safe-area-bottom, 0px))'}}>
                    <IonFabButton onClick={() => handleOpenNewAvailabilityModal()}>
                        <IonIcon icon={add}/>
                    </IonFabButton>
                </IonFab>
                <AvailabilityGuideModal isOpen={showGuide} onClose={() => updateShowGuide(false)}/>
            </StyledIonContent>
        </IonPage>
    );
};

export default AvailabilityPage;
